export const change_country = (country) => async (dispatch) => {
  dispatch({
    type: 'COUNTRY',
    payload: country,
  });
  localStorage.setItem('country', country);
};
